import CustomerShipmentsApiV2 from 'api/v2/admins/customer-shipments-api-v2'
import ConfirmationModal from 'components/organisms/confirmation-modal/confirmation-modal'
import { ALERT_TYPES } from 'constants/alert-constants'
import CustomerOrderShipmentView from 'domains/customer-order/molecules/shipment-view'
import PropTypes from 'prop-types'
import { useModal } from 'providers/modal-provider'
import React from 'react'
import { useHistory } from 'react-router'
import {
  Alert,
  Button,
  ListGroup,
  ListGroupItem
} from 'reactstrap'
import { STATUS, SHIPMENT_STATUS } from 'domains/customer-order/constants'

const propTypes = {
  id    : PropTypes.string,
  order : PropTypes.shape({
    number    : PropTypes.string,
    status    : PropTypes.string,
    shipments : PropTypes.array
  }),
  pageUtils       : PropTypes.any,
  setRefetchOrder : PropTypes.func
}


const CustomerOrderDetailShipmentPage = ({ id, order, pageUtils, setRefetchOrder }) => {
  const history = useHistory()

  const { showModal, hideModal } = useModal()

  const handleSelectNewShipment = (id) => {
    history.push({
      pathname: `/app/customer-orders/${id}/new-shipment`
    })
  }

  /**
   * Goes to Shipment Detail Page when clicking on the detail button
   * @param {number} id - Customer Shipment ID
   */
  const handleSelectDetailShipment = (id) => {
    history.push({
      pathname: `/app/customer-shipments/${id}`
    })
  }

  const handleClickCancel = (id) => {
    showModal(ConfirmationModal, {
      title              : 'Cancel Confirmation',
      children           : `Apakah kamu yakin akan cancel shipment ID ${id} ?`,
      handleConfirmation : async () => handleCancelShipment(id)
    })
  }

  // handler to cancel order
  const handleCancelShipment = (id) => {
    CustomerShipmentsApiV2.cancel(id)
      .then(() => {
        pageUtils.setAlertMsg('Shipment successfully cancelled', ALERT_TYPES.SUCCESS)
        setRefetchOrder(true)
      })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data))
      .finally(() => hideModal())
  }

  const cancelableShipmentStatus = [ 'pending', 'shipped' ]
  const isShipmentCancelable     = (shipment) => cancelableShipmentStatus.includes(shipment.status)

  const SHIPMENT_STATUS_NOTES_MAP = {
    [SHIPMENT_STATUS.FAILED]    : 'Proses pengiriman telah dibatalkan oleh jasa pengiriman.',
    [SHIPMENT_STATUS.CANCELLED] : 'Proses pengiriman telah dibatalkan oleh pihak Ops Tinkerlust.',
    [SHIPMENT_STATUS.RETURNED]  : 'Proses pengiriman telah dibatalkan oleh kurir jasa pengiriman dan paket sedang/telah dikembalikan ke kantor Tinkerlust.'
  }

  const latestShipment    = order.shipments?.slice(-1)[0]
  const isOrderProcessing = order.status === STATUS.PROCESSING

  const isShipmentRecreateable = latestShipment?.status in SHIPMENT_STATUS_NOTES_MAP

  const showShipmentNote = isOrderProcessing && isShipmentRecreateable

  return (
    <>
      {
        showShipmentNote && (
          <Alert color='info'>
            <i className='fas fa-info-circle mr-2' />
            <strong className='text-capitalize'>
              { `${latestShipment?.status}: ` }
            </strong>
            <p>
              { SHIPMENT_STATUS_NOTES_MAP[latestShipment?.status] }
              <br />
              { 'Untuk melanjutkan pengiriman silahkan tekan tombol ' }
              <strong>
                { 'New Shipment' }
              </strong>
              { ' untuk membuat shipment baru.' }
            </p>
          </Alert>
        )
      }



      <ListGroup flush>
        {
          order.shipments && order.shipments.map((shipment) => (
            <ListGroupItem key={ `shipment-list-item-${shipment.id}` }>
              <CustomerOrderShipmentView customerShipment={ shipment } />
              <Button
                className='float-right'
                color={ 'primary' }
                onClick={ () => handleSelectDetailShipment(shipment.id) }
              >
                { 'Detail' }
              </Button>

              {
                isShipmentCancelable(shipment) && (
                  <Button
                    className='float-right mr-3'
                    color={ 'danger' }
                    onClick={ () => handleClickCancel(shipment.id) }
                  >
                    { 'Cancel' }
                  </Button>
                )
              }

            </ListGroupItem>
          )).reverse()
        }
      </ListGroup>
      <div className='mt-3'>
        <Button
          block
          outline
          color='primary'
          onClick={ () => handleSelectNewShipment(id) }
        >
          { 'New Shipment' }
        </Button>
      </div>
    </>
  )
}

CustomerOrderDetailShipmentPage.propTypes = propTypes

export default CustomerOrderDetailShipmentPage
